import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be1a6eec")

_pushScopeId("data-v-be1a6eec")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" You are now on the Demo account. Try trading the popular instruments. Click to see the chart and analysis. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheMarketList = _resolveComponent("TheMarketList")
  const _component_t = _resolveComponent("t")
  const _component_GuideContent = _resolveComponent("GuideContent")
  const _component_GuideTarget = _resolveComponent("GuideTarget")

  return (_openBlock(), _createBlock(_component_GuideTarget, { name: "marketList" }, {
    bottom: _withId(() => [
      _createVNode(_component_GuideContent, { class: "mx-16" }, {
        default: _withId(() => [
          _createVNode(_component_t, { path: "market_14" }, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_TheMarketList, { read: _ctx.read }, null, 8, ["read"])
    ]),
    _: 1
  }))
})